import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Copyright = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1.833C10.862 1.833 1.833 10.863 1.833 22c0 11.138 9.03 20.167 20.167 20.167 11.138 0 20.167-9.03 20.167-20.167 0-11.138-9.03-20.167-20.167-20.167ZM0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.092 22c0-5.42 4.395-9.814 9.815-9.814 2.091 0 4.02.662 5.607 1.765a.917.917 0 1 1-1.046 1.505 7.96 7.96 0 0 0-4.561-1.437 7.982 7.982 0 0 0 0 15.962 7.96 7.96 0 0 0 4.561-1.437.917.917 0 0 1 1.046 1.505 9.794 9.794 0 0 1-5.607 1.765c-5.42 0-9.815-4.394-9.815-9.814Z"
  }));
});
Copyright.displayName = 'Copyright';
Copyright.defaultProps = {
  'aria-label': 'Copyright'
};
export default Copyright;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Copyright.js
// module id = 3760
// module chunks = 11